enum SCRIPT_TYPE {
  MOBILE = "MOBILE",
  MODERATED = "MODERATED",
  FOCUS_GROUP = "FOCUSGROUP",
}
export default SCRIPT_TYPE;
